// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginPage_wrapper__A0Pbg","content":"LoginPage_content__6UNzi","successStateWrapper":"LoginPage_successStateWrapper__1Fxo7"};